export const CreateLessonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path
      d="m20.5 6.5-3-3 1-1c1-.333 1.833-.167 2.5.5s.833 1.5.5 2.5l-1 1zM19 8 6 21H3v-3L16 5l3 3z"
      fill="#1E4878"
    />
  </svg>
);
